export default "__VITE_ASSET__BxOxeijf__"